import React from "react";
import PropTypes from "prop-types";
import Contributor from "../../../../../atoms/contributor";
import { humanizeDate } from "../../../../../utils/time-format";
import { get } from "lodash";
import { getAuthorPath } from "../../../../../../data/author";

import styles from "./styles.m.css";

class StorySecondaryCard extends React.Component {
  constructor(props) {
    super(props);
    this.dropdown = null;
    this.state = {
      dropdown: false,
      showRelativeTime: false
    };
  }

  render() {
    const { story, className, config } = this.props;

    return (
      <div className={`${styles["story-header"]} ${className}`}>
        {story.authors && story.authors.length ? (
          <div className={styles.contributors}>
            {story.authors.slice(0, 1).map((author, index) => {
              return (
                <Contributor
                  config={config}
                  path={getAuthorPath(author)}
                  key={author.id}
                  name={author.name}
                  type={get(author, ["contributor-role", "name"], "")}
                  iconColor="#4a4a4a"
                  className={styles["contributor"]}
                />
              );
            })}
          </div>
        ) : null}
        <div className={styles["published-time-wrap"]}>
          {story["first-published-at"] && (
            <span className={styles["published"]}>
              Published:
              <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                {humanizeDate(story["first-published-at"], this.state.showRelativeTime ? "relative" : "absolute")}
              </time>
            </span>
          )}
        </div>
      </div>
    );
  }
}

StorySecondaryCard.propTypes = {
  story: PropTypes.shape({
    "first-published-at": PropTypes.number,
    "last-published-at": PropTypes.number,
    headline: PropTypes.string,
    subheadline: PropTypes.string,
    contributor: PropTypes.shape(Contributor.propTypes)
  }),
  episodes: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  renderSocialMedia: PropTypes.func,
  className: PropTypes.string,
  config: PropTypes.shape({
    cinemaMode: PropTypes.bool,
    disableAuthorLink: PropTypes.bool
  }),
  subheadline: PropTypes.bool,
  readMore: PropTypes.bool
};

export default StorySecondaryCard;
